// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import Star from "@mui/icons-material/Star";

function WrapUnitImg(Props) {
  var starredOpt = Props.starred;
  var chosenOpt = Props.chosen;
  var s = Props.size;
  var unitId = Props.unitId;
  var starred = starredOpt !== undefined ? starredOpt : false;
  var chosen = chosenOpt !== undefined ? chosenOpt : false;
  return React.createElement("div", {
              className: CssJs.merge([
                    "relative",
                    CssJs.style([
                          CssJs.height(CssJs.px(s)),
                          CssJs.width(CssJs.px(s)),
                          CssJs.borderRadius(CssJs.px(6)),
                          CssJs.border(CssJs.px(3), CssJs.solid, CssJs.hex(Colors.tierColor(Sd.unitTier(Data.fixId(unitId))))),
                          CssJs.unsafe("boxShadow", chosen ? "0 0 2px 1px #facaff, 0 0 6px 4px #eea0ff" : "none")
                        ])
                  ])
            }, React.createElement("img", {
                  className: "rounded-[3px]",
                  height: String(s),
                  src: "https://ap.tft.tools/img/face_full/" + unitId + ".jpg?w=" + String(s),
                  width: String(s)
                }), starred ? React.createElement("div", {
                    className: "flex justify-center w-full absolute z-[1] top-[-10px]"
                  }, React.createElement("div", {
                        className: CssJs.merge([
                              "flex px-[2px] py-[1px]",
                              CssJs.style([
                                    CssJs.color(CssJs.hex(Colors.legendaryDesaturated2)),
                                    CssJs.background(Colors.blueGrey500Alpha(0.7)),
                                    CssJs.border(CssJs.px(1), CssJs.solid, CssJs.hex(Colors.legendaryDesaturated2)),
                                    CssJs.borderRadius(CssJs.px(8)),
                                    CssJs.fontSize(CssJs.px(12))
                                  ])
                            ])
                      }, Belt_Array.map(Belt_Array.range(1, 3), (function (i) {
                              return React.createElement(Star, {
                                          fontSize: "inherit",
                                          color: "inherit",
                                          key: String(i)
                                        });
                            })))) : null);
}

var make = WrapUnitImg;

export {
  make ,
  
}
/* Sd Not a pure module */
